import React, {useEffect, useState} from "react"
import {Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";
import {CheckboxEmpty, CheckboxFill} from "../../../../../assets/icons/defaultIcons";
import {PillarsService} from "../../../../services/pillars-api.service";
import {useUser} from "../../../../providers/UserContext";

export default function PillarChecboxComponent({ item , index, handleAntOptions}) {
    const[loader,setLoader] = useState(false);
    const[pillarItem,setPillarItem] = useState(false);
    const {pointUpdate , setPointUpdate} = useUser();

    useEffect(() => {
        setPillarItem(item)
    }, []);

    async function openNormalModal(item) {
        // setPillarLoader(true)
        setLoader(true)
        const response = await PillarsService.updateCurrentDatePillars(item.value, { status: !item.status });

        if (response?.data?.data?.status) {

            let updatedItem = handleAntOptions(item, !item.status)
            setPillarItem(updatedItem);
            setLoader(false)
            // setUpdateCheckLength(!updateCheckLength)
        }
    }
    return(
        <div className={`checkbox-box ${pillarItem.status && 'checked'}`} key={index}
             {...(loader ? {} : { onClick: () => openNormalModal(pillarItem) })}>
            {
                loader ?  <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} /> :
                    <span> {pillarItem.status ?<CheckboxFill/> : <CheckboxEmpty/>  }</span>


            }
            <span className={''}>{pillarItem.label}</span>
        </div>
    )
}